import {
    AfterViewInit,
    Component,
    DestroyRef,
    ElementRef,
    HostListener,
    inject,
    NgZone,
    OnDestroy,
    signal,
    ViewChild
} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet} from "@angular/router";
import {MenuComponent} from "./menu/menu.component";
import {BreadcrumbsComponent} from "./breadcrumbs/breadcrumbs.component";
import {InputComponent} from "@UI/input/input.component";
import {WideHeaderComponent} from "./wide-header/wide-header.component";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {CurrentService} from "@/app/api/current.service";
import {takeUntilDestroyed, toSignal} from "@angular/core/rxjs-interop";
import {MatProgressBar} from "@angular/material/progress-bar";
import {LoadingService} from "@services/loading.service";
import {SearchStringService} from "@services/search-string.service";
import {filter, switchMap} from "rxjs";
import {map, startWith} from "rxjs/operators";
import {getDeepestChildWithParams} from "@services/breadcrumbs.service";
import {CdkScrollable} from "@angular/cdk/scrolling";

@Component({
    selector: 'app-sportexam-layout',
    imports: [
        RouterOutlet,
        RouterLink,
        MenuComponent,
        BreadcrumbsComponent,
        InputComponent,
        WideHeaderComponent,
        ReactiveFormsModule,
        MatProgressBar,
        CdkScrollable,
    ],
    templateUrl: './sportexam-layout.component.html',
    styleUrl: './sportexam-layout.component.scss'
})
export class SportexamLayoutComponent implements AfterViewInit, OnDestroy {
    isReducedLeftSideOpen = signal(true)
    isOpenMobileMenu = signal(false);
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    destroyRef = inject(DestroyRef)
    ngZone = inject(NgZone)
    protected searchStringService = inject(SearchStringService)
    private resizeObserver?: ResizeObserver;
    public width = signal(0);

    @ViewChild('mobileMenu') mobileMenu!: ElementRef<HTMLElement>;
    @ViewChild('root', {static: false}) root?: ElementRef<HTMLElement>;

    currentService = inject(CurrentService)

    protected loadingService= inject(LoadingService)

    @HostListener('document:readystatechange', ['$event'])
    unloadHandler(event: Event) {
        // Здесь можно выполнять нужные действия, например, сохранять счетчик в localStorage
        console.log('Страница обновляется или закрывается', event);
        // this.currentService.getCurrent()
    }

    searchControl = new FormControl('')

    isMainPage = signal(true)


    prevUrl: string = ''

    constructor() {

        this.prevUrl = this.router.url;
        this.router.events
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const firstPrev = this.prevUrl.split('/')[1]
                const firstCurr = event.url.split('/')[1]

                this.isOpenMobileMenu.set(false)
                firstPrev !== firstCurr && this.searchStringService.clearSearchString()
                event.url === '/' ? this.isMainPage.set(true) : this.isMainPage.set(false)

                this.prevUrl = event.url
            }
        })
    }


    changeLeftSideMainWidth() {
        if (window.innerWidth >= 1024) {
            this.isReducedLeftSideOpen.set(!this.isReducedLeftSideOpen())
        } else {
            this.isOpenMobileMenu.set(!this.isOpenMobileMenu())
        }
    }


    reduceLeftSideMainWidth() {
        this.isReducedLeftSideOpen.set(!this.isReducedLeftSideOpen())
    }

    onWideHeaderClick($event: any) {
        $event.stopPropagation();
        this.isReducedLeftSideOpen.set(!this.isReducedLeftSideOpen())
    }

    onMobileMenuClick() {
        this.isOpenMobileMenu.set(false)
    }

    onClickOutside($event: Event) {
        const target = $event.target as HTMLElement;
        if (target !== this.mobileMenu.nativeElement) this.isOpenMobileMenu.set(false)
    }

    ngAfterViewInit() {
        this.resizeObserver = new ResizeObserver(entries => {
            // Так как событие вызывается вне Angular Zone - обновляем через ngZone.run
            this.ngZone.run(() => {
                for (let entry of entries) {
                    this.width.set(Math.round(entry.contentRect.width));
                    if (this.width() > 1024) {
                        this.isOpenMobileMenu.set(false)
                    }
                }
            });
        });
        this.root && this.resizeObserver.observe(this.root.nativeElement);
    }

    doShowSearchString = toSignal(
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            startWith(null), // Для триггера при инициализации
            map(() => getDeepestChildWithParams(this.route)),
            switchMap((route) =>
                route.data.pipe(
                    map((e) => e?.['searchString']),
                    takeUntilDestroyed(this.destroyRef),
                ),
            ),
        ),
    );

    ngOnDestroy() {
        this.resizeObserver?.disconnect();
    }
}
